import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

export class JobSlider {
  constructor() {
    this.initSwipers()
    this.setupModal()
  }

  initSwipers() {
    // 営業部門スライダー
    this.salesSwiper = new Swiper('.sales-slider', {
      modules: [Navigation],
      loop: true, // ループを有効にする
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 30,
    })

    // 生産部門スライダー
    this.productionSwiper = new Swiper('.production-slider', {
      modules: [Navigation],
      loop: true, // ループを有効にする
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 30,
    })

    // 技術開発部門スライダー
    this.technologySwiper = new Swiper('.technology-slider', {
      modules: [Navigation],
      loop: true, // ループを有効にする
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 30,
    })
  }

  setupModal() {
    const openBtns = document.querySelectorAll('.js-modal-open')
    const closeBtns = document.querySelectorAll('.js-modal-close')

    openBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const modalId = btn.getAttribute('data-modal')
        const slideIndex = parseInt(btn.getAttribute('data-slide'), 10) // スライド番号を整数に変換
        const modal = document.getElementById(modalId)

        if (modal) {
          modal.classList.add('is-active')
          document.body.style.overflow = 'hidden'

          // スライダーをスライド番号に移動
          if (modalId === 'sales-modal') {
            this.salesSwiper.slideTo(slideIndex)
          } else if (modalId === 'production-modal') {
            this.productionSwiper.slideTo(slideIndex)
          } else if (modalId === 'technology-modal') {
            this.technologySwiper.slideTo(slideIndex)
          }
        }
      })
    })

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const modal = btn.closest('.modal')
        if (modal) {
          modal.classList.remove('is-active')
          document.body.style.overflow = ''

          // モーダルが閉じられた時にスライダーをリセットする
          if (this.salesSwiper) {
            this.salesSwiper.destroy(true, true) // 営業部門スライダーを破棄
            this.salesSwiper = new Swiper('.sales-slider', {
              // 新しく再初期化
              modules: [Navigation],
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              spaceBetween: 30,
              loop: true, // ループを有効にする
            })
          }
          if (this.productionSwiper) {
            this.productionSwiper.destroy(true, true) // 生産部門スライダーを破棄
            this.productionSwiper = new Swiper('.production-slider', {
              modules: [Navigation],
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              spaceBetween: 30,
              loop: true,
            })
          }
          if (this.technologySwiper) {
            this.technologySwiper.destroy(true, true) // 技術開発部門スライダーを破棄
            this.technologySwiper = new Swiper('.technology-slider', {
              modules: [Navigation],
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              spaceBetween: 30,
              loop: true,
            })
          }
        }
      })
    })
  }
}
